<template>
    <div class="operation-form">
        <div class="operation-form-head">{{ title }}</div>
        <div class="form-box">
            <el-radio-group v-model="formData.operationType" style="width: 100%" @change="formData.amountOfMoney = ''">
                <div 
                    class="type-item" 
                    v-for="item in list"
                    :key="item.value"
                >
                    <el-radio :label="item.value">
                        {{ item.label }}
                    </el-radio>
                    <div class="input-data" v-if="formData.operationType === item.value">
                        <el-input 
                            :placeholder="t('amount_of_money_placeholder')" 
                            v-model="formData.amountOfMoney" 
                        >
                            <el-select 
                                v-if="item.type !== 'add'"
                                v-model="formData.adjustmentType" 
                                slot="prepend" 
                                placeholder=""
                            >
                                <el-option 
                                    v-for="item in adjustmentTypeList"
                                    :key="item.value"
                                    :label="item.label" 
                                    :value="item.value"
                                />
                            </el-select>
                        </el-input>
                    </div>
                </div>
            </el-radio-group>
        </div>
    </div>
</template>

<script>
const ADJUSTMENT_TYPE= {
    QUANTITY: '1',//按金额
    PERCENTAGE: '2'//按百分比
}
export default {
    name: 'OperationForm',
    props: [ 'title', 'list' , 'defaultData' ,'t' ],
    data() {
        const formData = Object.assign(
            { 
                operationType: '1',
                amountOfMoney: '',
                adjustmentType: ADJUSTMENT_TYPE.QUANTITY,
            },
            this.defaultData
        );
        const _this = this;
        return {
            formData,
            adjustmentTypeList: [
                { value: ADJUSTMENT_TYPE.QUANTITY, label: _this.t('by_amount') },
                { value: ADJUSTMENT_TYPE.PERCENTAGE, label: _this.t('by_percentage') },
            ],
        }
    },
    methods: {
        async getFormData() {
            const { operationType, amountOfMoney, adjustmentType } = this.formData;
            return {
                trigger_sub_action: operationType,
                trigger_action_detail: adjustmentType,
                trigger_action_value: amountOfMoney,
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.operation-form {
    padding: 8px 6px;
    border-radius: 4px;
    margin-bottom: 8px;
    &::v-deep {
        .el-input-group__prepend {
            width: 100px;
        }
    }
    &-head {
        border-bottom: 1px solid #d4d4d4;
        padding-bottom: 6px;
        margin-bottom: 8px;
    }
    .form-box {
        padding: 0 6px;
    }
    .type-item {
        padding: 4px 0;
    }
    .input-data {
        padding: 6px 0;
        width: 100%;
    }
}
</style>